import { fromJS, Map } from 'immutable';

export function request(state, { id }) {
    let unsettlement = state.get('unsettlement', Map());

    unsettlement = unsettlement.set(id, Map({
        state: 'IN_PROGRESS'
    }));

    return state.set('unsettlement', unsettlement);
}

export function error(state, { id, errors }) {
    let unsettlement = state.get('unsettlement', Map());

    unsettlement = unsettlement.set(id, Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state.set('unsettlement', unsettlement);
}

export function finish(state, { id, data }) {
    let unsettlement = state.get('unsettlement', Map());

    unsettlement = unsettlement.set(id, Map({
        state: 'FINISHED'
    }));

    let items = state.get('items', Map());
    items = items.set(id, fromJS(data));

    return state
        .set('items', items)
        .set('unsettlement', unsettlement);
}
